import React, { useContext, useEffect } from "react";
import { Container } from "react-bootstrap";
import Button from "../../../components/ButtonComponent/Button";
import DataTable from "../../../components/DataTableComponent/DataTable";
import TopBar from "../../../components/TopBarComponent/Topbar";
import TableBody from "../../../constants/dummyData.json";
import BackArrow from "../../../assets/images/Icons/backArrow.svg";
import ExcelIcon from "../../../assets/images/Icons/xlIcon.svg";
import { ReportZoneContext } from "../ReportZoneView";
import Filter from "../../../assets/images/Icons/filter.svg";
import ZoneFilter from "../../../components/ZoneFilterComponent/ZoneFilter";
import { baseURL } from "../../../api/Axios";
import { Spinner } from "react-bootstrap";
import AlertBox from "../../../components/AlertComponent/AlertBox";
import "./reportZone.css";
import CheckBoxFill from "../../../assets/images/CheckboxFillRectangle.svg";
import CheckBox from "../../../assets/images/CheckBoxRect.svg";
import LogoutIcon from "../../../assets/images/LogoutIcon.svg";
const tableHeader = [
  { title: "Employee code", prop: "EmployeeCode" },
  { title: "Name", prop: "EmployeeName" },
  { title: "Category Type", prop: "category" },
  { title: "Zone", prop: "zone" },
  { title: "In/Out", prop: "in_out" },
  { title: "Date", prop: "date" },
  { title: "Time", prop: "time" },
];

const tableContent = TableBody.EmployeeNameFilter;

const EmployeeName = ({ textContent }) => {
  const {
    goBack,
    reportZone,
    zoneNewExcel,
    fromDate,
    toDate,
    categoryListDropDown,
    currentPageData,
    pageCount,
    onPageChange,
    showModal,
    setShowModal,
    filterZone,
    setFilterZone,
    filterCategory,
    setFilterCategory,
    filterFromDate,
    setFilterFromDate,
    filterToDate,
    setFilterToDate,
    dataFilteredZone,
    dataFilteredByAll,
    filterInReportsSpinnerStatus,
    downloadExcelSpinnerStatus,
    visibleZone,
    setVisibleZone,
    visibleCategory,
    setVisibleCategory,
    logout,
    setShowAlert,
    showAlert,
    alertMessage,
    statusCode,
    reportCriteria, // extended day
    timeInterval, // time interval state
    setTimeInterval, // time interval set state
    extendStayReport, // extended stay report data
    onSubmitTimeInterval, // time interval filter submit function
    viewDetails, // on click name detail showing function
    downloadExtendReport, // extended report download data storing state
    //
    handleCheckboxChange,
    selectedExtentdstayRow,
    setSelectedExtentdstayRow,
    setSelectedRows,
    selectedRows,
    setAlertMessage,
    punchoutUsersManualy,
    setStatusCode,
    logoutSpinner,
    handleLogoutClick,
    reportAllDownload,
    onDownloadClick,
    onDownloadAllCatogoryClick
  } = useContext(ReportZoneContext);

  const extendedStayHeader = [
    // { title: "Employee code", prop: "EmployeeCode" },
    {
      title: "",
      prop: "checkbox",
      cell: (row) => (
        //   <input
        //   type="checkbox"
        //   className="extentedCheckbox"
        //  //checked={selectedExtentdstayRow[row.Id] || false}
        //  onChange={(e) => handleCheckboxChange(e, row.Id)}
        // />
        <div onClick={() => handleCheckboxChange(row)}>
          {selectedRows.some((selectedRow) => selectedRow.Id === row.Id) ? (
            <img src={CheckBoxFill} alt="Checked" />
          ) : (
            <img src={CheckBox} alt="Unchecked" />
          )}
        </div>
      ),
    },
    {
      title: "Name",
      prop: "EmployeeName",
      cell: (row) => (
        <div
          className="ertHeaderEvacuation"
          onClick={() => {
            viewDetails(row.Id, row.dataType);
          }}
        >
          {row.EmployeeName}
        </div>
      ),
    },
    { title: "Category Type", prop: "category" },
    { title: "Contact", prop: "contact" },
    { title: "Vehicle No.", prop: "vehicle_no" },
    { title: "Zone", prop: "zone" },
    { title: "In/Out", prop: "in_out" },
    { title: "Date", prop: "date" },
    { title: "Time", prop: "time" },
  ];
  const categoryList = [
    { id: false, name: "All Categories" },
    ...categoryListDropDown,
  ];
  // useEffect(() => {
  //   onSubmitTimeInterval(currentPageData);
  // }, [currentPageData]);
  const handleAlertSubmit = () => {
    if (statusCode == 401) {
      logout();
    } else if (statusCode == 200) {
      setShowAlert(false);
    } else {
      setShowAlert(false);
    }
  };

  return (
    <div className="name-filter">
      {filterInReportsSpinnerStatus && (
        <div className="spinner-overlay-report">
          <Spinner size="xl" className="custom-spinner-report" />
        </div>
      )}

      <TopBar />
      <ZoneFilter
        filterZone={filterZone}
        setFilterZone={setFilterZone}
        filterCategory={filterCategory}
        setFilterCategory={setFilterCategory}
        filterFromDate={filterFromDate}
        setFilterFromDate={setFilterFromDate}
        filterToDate={filterToDate}
        setFilterToDate={setFilterToDate}
        show={showModal}
        setShow={setShowModal}
        onSubmit={
          dataFilteredZone
          //reportCriteria === "all" ? dataFilteredByAll : dataFilteredZone
        }
        fromDate={fromDate}
        toDate={toDate}
        spinnerStatus={filterInReportsSpinnerStatus}
        visibleZone={visibleZone}
        setVisibleZone={setVisibleZone}
        visibleCategory={visibleCategory}
        setVisibleCategory={setVisibleCategory}
        reportFilterCriteria={reportCriteria}
        timeInterval={timeInterval}
        setTimeInterval={setTimeInterval}
        submitTimeInterval={onSubmitTimeInterval}
        categoryList={categoryList}
      />
      <Container>
        <div className="heading-row my-3">
          <div className="title-box">
            <img
              className="back-arrow"
              src={BackArrow}
              alt="Back Arrow"
              width={17}
              onClick={() => goBack()}
            />
            <p className="title-name">
              {reportCriteria === "extendedStay"
                ? textContent.titleExtendedStay
                : reportCriteria === "all"
                ? "All"
                : textContent.title}
            </p>
          </div>
          <div className="text-align">
            {/* reportCriteria === "all" */}

            {reportCriteria === "extendedStay" ? (
              <span className="filter" onClick={handleLogoutClick}>
                {logoutSpinner ? (
                  <Spinner size="xl" />
                ) : (
                  <>
                    <img src={LogoutIcon} alt="Logout icon" />
                    Punch Out
                  </>
                )}
              </span>
            ) : (
              <span
                onClick={() => {
                  setVisibleZone({ id: false, name: "All Zones" });
                  setVisibleCategory({ id: false, name: "All Categories" });
                  setShowModal(true);
                }}
                className="filter"
              >
                <img src={Filter} alt="Excel-icon" />
                Filter
              </span>
            )}
            {/* {reportCriteria !== "zone"  ? (
                <span className="filter" onClick={handleLogoutClick}>
                {logoutSpinner ? (
                  <Spinner size="xl" />
                ) : (
                  <>
                    <img src={LogoutIcon} alt="Logout icon" />
                    punchout
                  </>
                )}
              </span>
            ) : (
             
              <span
                onClick={() => {
                  setVisibleZone({ id: false, name: "All Zones" });
                  setVisibleCategory({ id: false, name: "All Categories" });
                  setShowModal(true);
                }}
                className="filter"
              >
                <img src={Filter} alt="Excel-icon" />
                Filter
              </span>
            )} */}

            <div
              className={
                reportCriteria === "extendedStay" ? "display-none" : ""
              }
            >
              <span>
                <label className="from-date-label">
                  {textContent.fromDateLabel}
                </label>
                <span className="date">{fromDate}</span>
              </span>
              <span>
                <label className="to-date-label">
                  {textContent.toDateLabel}
                </label>
                <span className="date border-line">{toDate}</span>
              </span>
            </div>

            {/* download button for zone base filter */}
            <button
            className= {reportCriteria === "zone" ? "excel-download-button-extentedStay" :"display-none"}
              // className={`${ 
              //   
              //     ? "show-button download-text"
              //     : "display-none"
              // }
              // ${downloadExtendReport ? "excel-download" : "disabled-button"}`}
              onClick={() => onDownloadAllCatogoryClick()}
              disabled={downloadExcelSpinnerStatus}
            >
              <img src={ExcelIcon} alt="Excel-icon" />
              {downloadExcelSpinnerStatus ? (
                <Spinner size="sm" />
              ) : (
             
                 textContent.downLoadText
              )}
            </button>
            {/* <span
              className={
                reportCriteria === "extendedStay" || reportCriteria === "all"
                  ? "display-none"
                  : "download-text"
              }
            >
              <a
                className={zoneNewExcel ? "excel-download" : "disabled-button"}
                href={
                  zoneNewExcel && downloadExcelSpinnerStatus === false
                    ? `${baseURL}/excel/${zoneNewExcel}`
                    : undefined
                }
              >
                <img src={ExcelIcon} alt="Excel-icon" />{" "}
                {downloadExcelSpinnerStatus ? (
                  <Spinner size="sm" />
                ) : (
              
                 textContent.downLoadText
                )}
              </a>
            </span> */}

            {/* Report - All dowload button */}
            {/* <span
              className={
                reportCriteria === "all" ? "download-text" : "display-none"
              }
            >
              <a
                className={
                  reportAllDownload ? "excel-download" : "disabled-button"
                }
                href={
                  reportAllDownload && downloadExcelSpinnerStatus === false
                    ? `${baseURL}/excel/${reportAllDownload}`
                    : undefined
                }
              >
                <img src={ExcelIcon} alt="Excel-icon" />{" "}
                {downloadExcelSpinnerStatus ? (
                  <Spinner size="sm" />
                ) : (
              
                  textContent.downLoadText
                )}
              </a>
            </span> */}
      <button
            className= {reportCriteria === "all" ? "excel-download-button-extentedStay" :"display-none"}
              // className={`${ 
              //   
              //     ? "show-button download-text"
              //     : "display-none"
              // }
              // ${downloadExtendReport ? "excel-download" : "disabled-button"}`}
              onClick={() => onDownloadAllCatogoryClick()}
              disabled={downloadExcelSpinnerStatus}
            >
              <img src={ExcelIcon} alt="Excel-icon" />
              {downloadExcelSpinnerStatus ? (
                <Spinner size="sm" />
              ) : (
             
                textContent.downLoadText
              )}
            </button>
            {/* Extended stay download button */}
            {/* <span
              className={
                reportCriteria === "extendedStay"
                  ? "show-button download-text"
                  : "display-none"
              }
            >
              <a
                className={
                  downloadExtendReport ? "excel-download" : "disabled-button"
                }
                href={
                  downloadExtendReport && downloadExcelSpinnerStatus === false
                    ? `${baseURL}/excel/${downloadExtendReport}`
                    : undefined
                }
              >
                <img src={ExcelIcon} alt="Excel-icon" />{" "}
                {downloadExcelSpinnerStatus ? (
                  <Spinner size="sm" />
                ) : (
                  textContent.downLoadText
                )}
              </a>
            </span> */}
            <button
            className= {reportCriteria === "extendedStay" ? "excel-download-button-extentedStay" :"display-none"}
              // className={`${ 
              //   
              //     ? "show-button download-text"
              //     : "display-none"
              // }
              // ${downloadExtendReport ? "excel-download" : "disabled-button"}`}
              onClick={() => onDownloadClick()}
              disabled={downloadExcelSpinnerStatus}
            >
              <img src={ExcelIcon} alt="Excel-icon" />
              {downloadExcelSpinnerStatus ? (
                <Spinner size="sm" />
              ) : (
             
                textContent.downLoadText
              )}
            </button>
          </div>
        </div>
        <DataTable
          tableData={
            reportCriteria === "extendedStay" ? extendStayReport : reportZone
          }
          header={
            reportCriteria === "extendedStay" ? extendedStayHeader : tableHeader
          }
          isPagination={true}
          onPageChange={(e) => onPageChange(e)}
          currentPage={currentPageData}
          pageCount={pageCount}
        />
      </Container>
      <AlertBox
        show={showAlert}
        setShow={setShowAlert}
        alertMessage={alertMessage}
        handleSubmit={
          handleAlertSubmit
          // statusCode == 401 ? () => logout() :() => setShowAlert(false)
        }
      />
    </div>
  );
};

export default EmployeeName;
